module.exports = __webpack_public_path__ + "src/assets/img/podolskaya.2de061ba.jpg";